import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import {
  getFlightMarkersState,
  getGCPRequestState,
  getSiteState,
  IStoreState,
} from "../../../redux/rootReducer";
import Dropdown from "./Dropdown";
import {
  AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV,
  AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV_ALL,
  AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV_PROBLEM,
} from "../../_autotest-constants";
import config from "../../../config";
import { IGcpAppDispatch } from "../../../redux/store";
import {
  createGcpRequestCsvAll,
  createGcpRequestCsvProblem,
} from "../../../redux/computables/csvFile/csvFile";
import { userDownloadsAllCsv, userDownloadsRequestedCsv } from "./scenarios";
import currentGcpRequestStore from "../currentGCPRequestStore";
import { getEpsgFromSrs } from "../../../utils/getEpsgFromSrs";
import { IGCPRequestState } from "../../../redux/modules/gcpRequest/reducer";

interface ICsvDownloadButtonProps {
  csvFileAll: string;
  csvFileProblem: string;
  dispatch: IGcpAppDispatch;
  isPilot: boolean;
  gcpRequest?: IGCPRequestState;
}

const CsvDownloadButton = ({
  dispatch,
  csvFileAll,
  csvFileProblem,
  isPilot,
  gcpRequest,
}: ICsvDownloadButtonProps) => {
  const srs = currentGcpRequestStore((store) => store.site).srs;
  const epsg = getEpsgFromSrs(srs);

  useEffect(() => {
    if (!gcpRequest.loading && srs) {
      const urlParams = new URLSearchParams(window.location.search);
      const downloadCsv = urlParams.get("downloadCsv") === "true";
      if (downloadCsv) {
        dispatch(userDownloadsRequestedCsv(csvFileProblem));
      }
    }
  }, [gcpRequest, srs]);

  return (
    <Dropdown
      label={`CSV ${isPilot ? `(EPSG:${epsg})` : ""}`}
      className={AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV}
      icon={<img src="icon-download.svg" />}
      options={[
        {
          label:
            config.language === "ru" ? "Все опознаки" : "All Flight Markers",
          className: AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV_ALL,
          onClick: () => {
            dispatch(userDownloadsAllCsv(csvFileAll));
          },
        },
        {
          label:
            config.language === "ru"
              ? "Запрошенные опознаки"
              : "Requested Flight Markers",
          className: AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV_PROBLEM,
          onClick: () => {
            dispatch(userDownloadsRequestedCsv(csvFileProblem));
          },
        },
      ]}
    />
  );
};

export default connect(
  (
    state: IStoreState,
    { isPilot }: Pick<ICsvDownloadButtonProps, "isPilot">,
  ) => ({
    csvFileAll: createGcpRequestCsvAll(
      getGCPRequestState(state),
      getFlightMarkersState(state),
      getSiteState(state),
      isPilot,
    ),
    csvFileProblem: createGcpRequestCsvProblem(
      getGCPRequestState(state),
      getFlightMarkersState(state),
      getSiteState(state),
      isPilot,
    ),
    gcpRequest: getGCPRequestState(state),
  }),
)(CsvDownloadButton);
